//开通会员记录

import UltMeta, { Meta } from "./UltMeta/index";

class OpenMode extends UltMeta {
    WECHAT_PAY = new Meta(1, "微信支付");
    ALIPAY = new Meta(2, "支付宝");
    ACTIVATION_CODE = new Meta(3, "激活码");
}

export const OPEN_MODE = new OpenMode();
